import { MessageOutlined } from '@ant-design/icons';
import { Button, Form, Input, Modal, Select } from 'antd';
import _ from 'lodash';
import moment from 'moment';
import React, { useEffect, useRef, useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { reactLocalStorage } from 'reactjs-localstorage';
import { bindActionCreators } from 'redux';
import { clearOrder, setOrder } from '../../actions/orderAction';
import { updateManualPickupTimeSetup } from '../../actions/pickupTimeAction';
import {
  addOrderInfo,
  addWaitingOrder,
  removePosOrder,
  removeWaitingOrder,
  removeWaitingOrderByOrderAwaitId,
  updateWaitingOrder,
} from '../../actions/posAction';
import {
  calcShippingDataAsync,
  changeItemPreparedAsync,
  createOrderAsync,
  createOrderAwaitAsync, createOrderAwaitAtCloudFlareWorker,
  createOrderInfoAtCloudFlareWorker,
  deleteOrderAwaitAsync,
  deleteOrderAwaitAtCloudFlareWorker,
  getOrderInfoDetailFromCloudFlareWorker,
  getOrderInfoListFromCloudFlareWorker,
} from '../../api/api';
import { httpGet, httpPost, httpUrl } from '../../api/httpClient';
import Const from '../../const';
import {getUseAutoConfirmOrder, getUseNotifyOrderEtc} from '../../lib/module';
import {isExistsPendingOrder, removePendingOrder} from '../../lib/util/orderUtil';
import {
  dosiguCodeReplace,
  getOrderStatusString,
  orderStatusCode,
  paymentMethodString,
  pickupTimeCode,
  pickupTimeValue,
  modalStyle, modalErrorStyle,
} from '../../lib/util/codeUtil';
import { comma } from '../../lib/util/numberUtil';
import ChatDetail from '../../pages/chat/ChatDetail';
import DeliveryDetailModal from '../modal/DeliveryDetailModal';
import color from '../../res/color';

const Search = Input.Search;
const FormItem = Form.Item;
const today = new Date();
let localStorageOrderInfos = [];
let cloudFlareOrderInfo = [];

const isMobile = () => {
  // // console.log(`window. width: ${window.innerWidth}, height: ${window.innerHeight}, maxMobileWidth: ${Const.maxMobileWidth}`);
  return window.innerWidth < Const.maxMobileWidth;
};

function useInterval(callback, delay) {
  const savedCallback = useRef();

  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  useEffect(() => {
    function tick() {
      savedCallback.current();
    }

    if (delay !== null) {
      let id = setInterval(tick, delay);
      return () => clearInterval(id);
    }
  }, [delay]);
}

let isUseListByApi = false;

const ProcList = ({
  waitingOrders,
  posOrders,
  alert,
  orderReducer,
  loginReducer,
  posReducer,
  updateManualPickupTimeSetup,
}) => {
  const dispatch = useDispatch();
  const [detailModalOpen, setDetailModalOpen] = useState(false);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 5,
    orderStatuses: [
      orderStatusCode.order,
      orderStatusCode.assign,
      orderStatusCode.pickup,
    ],
  });

  const [list, setList] = useState([]);
  const [duplicateList, setDuplicateList] = useState([]);
  const [total, setTotal] = useState(0);
  const [selectedRow, setSelectedRow] = useState(null);
  const history = useHistory();
  const [radioType, setRadioType] = useState(0);
  const [searchType, setSearchType] = useState(0);
  const [searchText, setSearchText] = useState('');
  const [posOrderCount, setPosOrderCount] = useState(0);
  const [waitingOrderCount, setWaitingOrderCount] = useState(0);
  const [largeList, setLargeList] = useState(true);

  const [selectedRider, setSelectedRider] = useState(null);
  const [riderChatOpen, setRiderChatOpen] = useState(false);

  const [deliveryData, setDeliveryData] = useState({
    deliveryEnabled: true,
  });
  const [frBasicPickupTime, setFrBasicPickupTime] = useState(15);
  const [selectedPickupTime, setSelectedPickupTime] = useState(null);
  const [sortType, setSortType] = useState(0);
  // const [arriveReqTime, setArriveReqTime] = useState(0);

  useEffect(async () => {
    await getListByApi();
    await loadOrderInfo();
    /* #2666 가맹점 대기주문 접수시 이전 오더가 보이는 현상
    수정을 위해 주석 처리
    global.setProcListOrders = getListAsync;
     */
  }, []);

  useEffect(() => {
    updateDeliveryData();
  }, []);

  const updateDeliveryData = () => {
    setDeliveryData(
      reactLocalStorage.getObject(Const.appName + '#deliverydata')
    );
    setFrBasicPickupTime(
      reactLocalStorage.getObject(Const.appName + '#basicPickupTime')
    );
  };

  useInterval(() => {
    /* #2666 가맹점 대기주문 접수시 이전 오더가 보이는 현상
    수정을 위해 주석 처리
    if (
      posOrderCount != posOrders.length ||
      waitingOrderCount != waitingOrders.length
    ) {
      getListByApi().finally( () => {
        setPosOrderCount(posOrders.length);
        setWaitingOrderCount(waitingOrders.length);
      });
    }
    */

    getListByApi(true).finally(() => {
      setPosOrderCount(posOrders.length);
      setWaitingOrderCount(waitingOrders.length);
    });
  }, Const.orderListPollingTimeMS);

  useEffect(() => {
    /* #2666 가맹점 대기주문 접수시 이전 오더가 보이는 현상
    수정을 위해 주석 처리, 중복 호출 방지

    const interval = setInterval(() => {
      getListByApi();
    }, 20000);

    getListByApi().finally(()=>{});

    return () => {
      clearInterval(interval);
    };
     */
  }, [waitingOrders, posOrders, pagination, searchType, searchText, sortType]);

  const getListByApi = async (isHideLoading) => {
    if (false !== isUseListByApi) {
      return;
    }
    isUseListByApi = true;

    // // console.log('getListByApi');
    try {
      const res = await httpGet(
        httpUrl.orderProcList,
        [1000, 1, [1, 2, 3]],
        {},
        true === isHideLoading
      );
      // // console.log('getListByApi res');
      // // console.log(res);
      if (res.result !== 'SUCCESS') return;

      if (Array.isArray(res.data.orders))
        dispatch(setOrder('NEW', res.data.orders));

      // // console.log('getListAsync after getListApi');
      updateDeliveryData();

      await getListAsync(res.data.orders);
    } catch (e) {}

    isUseListByApi = false;
  };

  const getListAsync = async (reduxOrders) => {
    // // console.log(reduxOrders);
    try {
      let orders = mergeRows(reduxOrders, waitingOrders, posOrders);
      if (searchType === 1) {
        orders = orders.filter(
          (x) =>
            x.destAddr1.indexOf(searchText) > -1 ||
            (typeof x.destAddr2 !== 'undefined' &&
              x.destAddr2.indexOf(searchText) > -1)
        );
      } else if (searchType === 2) {
        orders = orders.filter((x) => x.custPhone === searchText);
      } else if (searchType === 0) {
        orders = orders.filter(
          (x) =>
            x.destAddr1.indexOf(searchText) > -1 ||
            (typeof x.destAddr2 !== 'undefined' &&
              x.destAddr2.indexOf(searchText) > -1) ||
            x.custPhone === searchText
        );
      }

      const items = orders;
      if (items.length > 0) {
        const grouped = _(items)
          .groupBy(
            (item) => `"${item.orderPrice}+${item.destAddr1}+${item.destAddr2}"`
          )
          .map((data, id) => ({
            condition: id,
            array: data,
          }))
          .value()
          .filter((x) => x.array.length > 1);

        let duplicate = [];
        grouped.map((x) => {
          for (let i = 0; i < x.array.length; ++i) {
            duplicate.push(x.array[i].idx);
          }
        });
        setDuplicateList(duplicate);
      }

      // // console.log('===== getListAsync invoked =====');
      // // console.log(orderReducer.orders);
      // // console.log([...orders]);

      setTotal(orders.length);
      setList([...orders]);
      // dispatch(clearOrder());
    } catch (e) {
      setTotal(0);
      setList([]);
      setDuplicateList([]);
      // dispatch(clearOrder());
      console.warn('getListAsync failed. ' + e);
    }
  };

  global.setProcListOrders = getListAsync;

  const mergeRows = (rows, waitingRows, posRows) => {
    let list = [];
    if (waitingRows.length > 0) {
      waitingRows.forEach((row) => {
        list.push({
          ...row,
          waiting: true,
          frIdx: 0,
          riderName: null,
          riderPhone: null,
          orderStatus: 0,
        });
      });
    }
    if (posRows.length > 0) {
      posRows.forEach((row) => {
        list.push({
          ...row,
          frIdx: 0,
          riderName: null,
          riderPhone: null,
          orderStatus: 0,
        });
      });
    }
    if (sortType === 0) {
      list.sort((a, b) => {
        if (a.idx && b.idx) return a.idx - b.idx;
        else return moment(a.orderDate) - moment(b.orderDate);
      });
      rows.sort((a, b) => {
        if (a.idx && b.idx) return a.idx - b.idx;
        else return moment(a.orderDate) - moment(b.orderDate);
      });
      return [...list, ...rows];
    } else if (sortType === 1) {
      list = [...list, ...rows];
      list.sort((a, b) => moment(a.orderDate) - moment(b.orderDate));
    } else {
      list = [...list, ...rows];
      list.sort((a, b) => moment(b.orderDate) - moment(a.orderDate));
    }

    return list;
  };

  const calculatePickupTimeIdx = (refPickupTimeIndex, pickUpTime) => {
    const calculated =
      pickupTimeValue[refPickupTimeIndex] >= pickUpTime
        ? pickupTimeValue[refPickupTimeIndex]
        : pickUpTime;
    return pickupTimeValue.indexOf(calculated);
  };

  const onConfirmOder = (row, mobile) => {
    // console.log(row);
    if (!row) return;
    if (mobile !== isMobile()) return;

    const arriveReqTime = row.arriveReqTime;
    if (row.orderStatus === orderStatusCode.none) {
      const totalDelayTime = deliveryData.delayPickupTime + frBasicPickupTime;
      if (row.arriveReqTime == null) {
        const refPickupTimeIdx = reactLocalStorage.getObject(
          Const.appName + '#refPickupTime'
        );

        const pickupTimeIdx = calculatePickupTimeIdx(
          refPickupTimeIdx,
          totalDelayTime
        );
        row.arriveReqTime = pickupTimeValue[pickupTimeIdx];
      } else {
        row.arriveReqTime =
          totalDelayTime > row.arriveReqTime
            ? totalDelayTime
            : row.arriveReqTime;
      }
      // console.log('row.arriveReqTime', row.arriveReqTime);
      Modal.confirm({
        ...modalStyle,
        content: (
          <div>
            <div>바로 주문을 접수 하시겠습니까?</div>
            <div style={{ display: 'flex' }}>
              <div>픽업시간 :</div>
              <Select
                style={{
                  width: '5rem',
                  marginLeft: 20,
                }}
                defaultValue={row.arriveReqTime}
                onSelect={(value) => {
                  row.arriveReqTime = value;
                }}>
                {pickupTimeValue.map((value, index) => {
                  if (index === 0) return null;
                  return (
                    value >=
                      deliveryData.delayPickupTime + frBasicPickupTime && (
                      <Select.Option key={index} value={value}>
                        {value > 1000 ? `후${value % 1000}분` : `${value}분`}
                      </Select.Option>
                    )
                  );
                })}
              </Select>
            </div>
          </div>
        ),
        okText: '확인',
        cancelText: '취소',
        async onOk() {
          await registCall(row);
        },
        onCancel() {
          row.arriveReqTime = arriveReqTime;
        },
      });
    } else {
      openDetailModal(row);
    }
  };

  const onChangeItemFlag = async (event, order) => {
    changeItemPreparedAsync(order).then((result) => {
      if (result === 'SUCCESS') {
        setList(
          list.map((row) =>
            row.idx === order.idx
              ? { ...row, itemPrepared: !order.itemPrepared }
              : row
          )
        );
      } else {
        Modal.error({
          title: '조리완료 상태변경 오류',
          content: <div>오류가 발생하였습니다. 다시 시도해 주십시오.</div>,
          ...modalErrorStyle,
        });
      }
    });
    event.stopPropagation();
  };

  const cancelOrder = (event, order) => {
    Modal.confirm({
      title: '접수를 취소합니다.',
      content: '접수를 취소하시겠습니까?',
      ...modalStyle,
      okText: '확인',
      cancelText: '취소',
      onOk() {
        httpPost(httpUrl.orderCancel, [], {
          orderIdx: order.idx,
        }).then((res) => {
          if (res.result === 'SUCCESS' && res.data === 'SUCCESS') {
            //Do nothing...
          } else {
            Modal.error({
              title: '접수취소 오류',
              content: <div>오류가 발생하였습니다. 다시 시도해 주십시오.</div>,
              ...modalErrorStyle,
            });
          }
        });
      },
    });
    event.stopPropagation();
  };

  const onUpdateItem = (event, row) => {
    Modal.confirm({
      icon: <MessageOutlined style={{color: color.warn}}/>,
      content: '대기 주문을 수정하시겠습니까?',
      okButtonProps: {
        className: color.okButtonClassName
      },
      cancelButtonProps: {
        className: color.cancelButtonClassName
      },
      okText: '확인',
      cancelText: '취소',
      onOk() {
        // console.log('update item row');
        // console.log(row);
        // updateManualPickupTimeSetup(true);
        history.push({
          pathname: '/main',
          state: row,
        });
      },
      onCancel() {},
    });
    event.stopPropagation();
  };

  const onDeleteItem = (event, item) => {
    Modal.confirm({
      icon: <MessageOutlined style={{color: color.warn}}/>,
      content: '대기 주문을 삭제하시겠습니까?',
      okButtonProps: {
        className: color.okButtonClassName
      },
      cancelButtonProps: {
        className: color.cancelButtonClassName
      },
      okText: '확인',
      cancelText: '취소',
      async onOk() {
        /*deleteOrderAwaitAtCloudFlareWorker(item); // clf d1에 존재하는 대기주문 삭제*/
        await httpPost(httpUrl.orderAwaitDelete, [item.id], {}); // TODO ojoomi: redis에 있는 대기주문이 모두 없어지면 이 라인 코드 삭제
        removePendingOrder(item);
        //await getOrderAwaitList(); 해당 라인을 주석처리 하지 않으면 대기 주문 삭제 시 1)남은 대기주문 순서 꼬임, 2)대기주문이 부분만 보이다가 전체가 보여지는 현상들이 발생하여 주석처리
      },
      onCancel() {},
    });
    event.stopPropagation();
  };

  const getDeliveryInfo = (order) => {
    if (!order.arriveReqTime) {
      return '';
    }
    const index = pickupTimeValue.findIndex((x) => x === order.arriveReqTime);
    if (index < 0) return order.arriveReqTime + '분';
    return pickupTimeCode[index];
  };

  const openRiderChatModal = (riderIdx, riderName, event) => {
    setSelectedRider({ idx: riderIdx, riderName });
    setRiderChatOpen(true);
    event.stopPropagation();
  };

  const closeRiderChatModal = () => {
    setRiderChatOpen(false);
  };

  const openDetailModal = (row) => {
    setSelectedRow(row);
    setDetailModalOpen(true);
  };

  const closeDetailModal = (updatedOrder) => {
    if (updatedOrder !== null && typeof updatedOrder === 'object') {
      setList(
        list.map((row) => (row.idx === updatedOrder.idx ? updatedOrder : row))
      );
    }
    setDetailModalOpen(false);
    setSelectedRow(null);
  };

  const onSearch = (text) => {
    setSearchType(radioType);
    setSearchText(text);
  };
  const loadOrderInfo = async () => {
    // 기존 로컬스토리지 주문정보
    let orderInfos = reactLocalStorage.getObject(
        Const.appName + '#orderInfo'
    );
    if (Array.isArray(orderInfos)) {
      localStorageOrderInfos = orderInfos;
    }

    // cloudflare 주문 정보
    try {
      const orderInfos = await getOrderInfoListFromCloudFlareWorker();
      if (orderInfos && Array.isArray(orderInfos)) {
        cloudFlareOrderInfo = orderInfos;
      }
    } catch (e) {
      console.error('Error while loading orderInfo', e);
    }
  };

  const registCall = async (data, self) => {
    const distRes = await calcShippingDataAsync(data.destAddr1, data.destAddr3);

    data.latitude = distRes.lat;
    data.longitude = distRes.lng;
    data.basicDeliveryPrice = distRes.deliveryBasicPrice;
    data.extraDeliveryPrice = distRes.deliveryAddPrice;
    const bmOrderCode = data.orderCode ? data.orderCode : null;

    let formData = {
      ...data,
      orderDate: '',

      // 대기주문 form에는 없는 주문 관련 정보들
      bmOrderCode,
      deliveryPrice: data.basicDeliveryPrice + data.extraDeliveryPrice,
      ncashPayEnabled: true,
      itemPrepared: data.itemPrepared || 'false',
      packAmount: data.packAmount || 1,
      orderStatus: 1,
      waitingStatus: 0,
    };

    const result = await createOrderAsync(formData);

    if (result === 'DELIVERY_NOT_ENABLED') return;
    if (result === 'SUCCESS') {
      if (formData.custPhone.length >= 7) {
        const prevOrderInfo = localStorageOrderInfos.find((x) => x.id === formData.custPhone);
        // 하나 찾아서 지우지 말고 전체 리스트 필터링
        const filteredList = localStorageOrderInfos.filter((x) => x.id !== formData.custPhone);
        localStorageOrderInfos = filteredList;
        reactLocalStorage.setObject(Const.appName + '#orderInfo', filteredList);

        const orderInfo = cloudFlareOrderInfo.find(
            (x) => x.metadata && x.metadata.id === formData.custPhone
        );
        let orderCount = 1;
        if (orderInfo) {
          const orderDetail = await getOrderInfoDetailFromCloudFlareWorker(
              formData.custPhone
          );
          orderCount =
              orderDetail && orderDetail.orderCount
                  ? orderDetail.orderCount + 1
                  : 1;
        }
        if (prevOrderInfo) {
          orderCount =
              prevOrderInfo && prevOrderInfo.orderCount
                  ? prevOrderInfo.orderCount + 1
                  : 1;
        }

        try {
          const res = await createOrderInfoAtCloudFlareWorker({
            id: formData.custPhone,
            custPhone: formData.custPhone,
            destAddr1: formData.destAddr1,
            destAddr2: formData.destAddr2,
            destAddr3: formData.destAddr3,
            custMessage: formData.custMessage,
            orderCount,
          });
          if (!orderInfo && res.data.result === 'success') {
            const list = await getOrderInfoListFromCloudFlareWorker();

            cloudFlareOrderInfo = list;
          }
          if (res.data.result === 'INVALID_USER_INFO') {
            Modal.warn({
              title: '주문정보 저장 실패',
              content: '주문정보 저장에 실패했습니다. 다시 로그인해주세요.',
              ...modalStyle,
            });
          }
        } catch (e) {}
      }

      // 지연시간 해제 상태에서 주문 접수 성공시 #refPickupTime(지연 없을때의 통상 픽업시간)을 업데이트
      if (deliveryData.delayPickupTime === 0) {
        const arriveReqTime = formData.arriveReqTime;
        reactLocalStorage.setObject(
          Const.appName + '#refPickupTime',
          pickupTimeValue.indexOf(arriveReqTime)
        );
      }

      deleteOrderAwaitAsync(data); //TODO ojoomi: redis에 있는 대기주문이 모두 없어지면 이 라인 코드 삭제
      /*deleteOrderAwaitAtCloudFlareWorker(data); //clf d1에 있는 대기주문 삭제*/
      dispatch(removeWaitingOrderByOrderAwaitId(data.id));
    } else if (result == 'BRANCH_CLOSED') {
      let message = '지점 영업시간이 아닙니다. 지점 관리자에게 문의하세요.';
      Modal.error({
        title: '배달요청 실패',
        content: <div>{message}</div>,
        ...modalErrorStyle,
        onOk() {},
      });
    } else if (result == 'INVALID_USER_STATUS') {
      let message = '유효하지 않은 사용자입니다.';
      Modal.error({
        title: '배달요청 실패',
        content: <div>{message}</div>,
        ...modalErrorStyle,
        onOk() {},
      });
    } else if (result == "DUPLICATE_BM_ORDER_CODE") {
      Modal.error({
        title: "배민 주문번호 중복",
        content: "이미 존재하는 주문번호가 있으니 다시 한번 확인바랍니다.",
        ...modalErrorStyle,
      });
    } else {
      // console.log('result:' + result);
      let message =
        '시스템에러로 배달요청에 실패하였습니다. 잠시 후 다시 시도해주세요.';
      if (
        result === 'NOT_ENOUGH_NCASH' ||
        result === 'NCASH_AUTO_CHARGE_FAIL'
      ) {
        message = '예치금이 부족합니다. 예치금 충전 후 다시 시도해주세요.';
        const useEtcVoiceGuidance = getUseNotifyOrderEtc();
        if (useEtcVoiceGuidance) {
          let audio = new Audio('11.wav');
          audio.volume = this.props.posReducer.volume;
          audio.crossOrigin = 'anonymous';
          audio.play();
        }
      } else if (result === 'DELIVERY_START_DISABLED_AREA') {
        message = '배달요청이 허용되지 않는 지역의 가맹점입니다.';
      } else if (result === 'DELIVERY_END_DISABLED_AREA') {
        message = '배달요청이 허용되지 않는 주소입니다.';
      }
      Modal.error({
        title: '배달요청 실패',
        content: <div>{message}</div>,
        ...modalErrorStyle,
        onOk() {},
      });
    }
  };

  const isShowAwaitOrderItem = (order) => {
    if (!getUseAutoConfirmOrder())
      return true;  //자동 접수가 off이면 모든 주문 보여줌

    if (order.orderStatus  !== orderStatusCode.none)
      return true;  //대기주문이 아니면 보여줌

    let exists = isExistsPendingOrder(order);
    return exists;   //실패리스트에 있으면 보여줌
  };

  const getOrderAwaitList = async () => {
    const res = await httpPost(httpUrl.getOrderAwaitList, [], {});

    let list = [];
    res.data.orderAwaitList.forEach((stringOrder) => {
      list.push(JSON.parse(stringOrder));
    });

    for (let i = 0; i < list.length; i++) {
      let orderAwait = list[i];

      if (
          posReducer.waitingOrders.find((order) => orderAwait.id === order.id)
      ) {
        dispatch(updateWaitingOrder(orderAwait));
      } else {
        dispatch(addWaitingOrder(orderAwait));
      }
    }

    for (let i = 0; i < posReducer.waitingOrders.length; i++) {
      const wo = posReducer.waitingOrders[i];

      if (
        wo.id &&
        list.findIndex((orderAwait) => orderAwait.id === wo.id) < 0
      ) {
        if (wo.error) {
          wo.error = false;
          await createOrderAwaitAsync(wo); //TODO ojoomi #6682일감에 따라 d1 정식배포전까지 대기주문 생성은 기존 redis에 write하도록 변경
          /*await createOrderAwaitAtCloudFlareWorker(wo); // 대기주문 redis => clf d1으로 관리하도록 변경*/
        } else {
          dispatch(removeWaitingOrderByOrderAwaitId(wo.id));
        }
      }
    }
  };

  const skinType = Const.skinType.toUpperCase();

  return (
    <div>
      <DeliveryDetailModal
        data={selectedRow}
        isOpen={detailModalOpen}
        close={closeDetailModal}
      />

      {/* <ScrollView className="mobile"> */}

      <div className="delivery-element-menu2">
        <div className="delivery-element-menu-all delivery-menu-top">
          <div
            className={radioType === 0 && skinType === "GOGOIT"
                ? 'gogoit-delivery-element-menu-text3 active'
                : radioType === 0
                    ? 'delivery-element-menu-text3 active'
                    : 'delivery-element-menu-text3'
            }
            onClick={() => {
              setRadioType(0);
            }}>
            전체
          </div>
          <div
            className={radioType === 1 && skinType === "GOGOIT"
                ? 'gogoit-delivery-element-menu-text3 active'
                : radioType === 1
                    ? 'delivery-element-menu-text3 active'
                    : 'delivery-element-menu-text3'
            }
            onClick={() => {
              setRadioType(1);
            }}>
            고객주소
          </div>
          <div
            className={radioType === 2 && skinType === "GOGOIT"
                ? 'gogoit-delivery-element-menu-text3 active'
                : radioType === 2
                    ? 'delivery-element-menu-text3 active'
                    : 'delivery-element-menu-text3'
            }
            onClick={() => {
              setRadioType(2);
            }}>
            전화번호
          </div>
          <FormItem>
            {/* <Radio.Group value={radioType}>
                            <Radio style={{ fontSize: 18 , marginTop: 1}} value={0} checked={true} onClick={() => { setRadioType(0); }}>전체</Radio>
                            <Radio style={{ fontSize: 18 , }} value={1} onClick={() => { setRadioType(1); }}>고객 주소</Radio>
                            <Radio style={{ fontSize: 18 , }} value={2} onClick={() => { setRadioType(2); }}>고객 전화번호</Radio>
                              </Radio.Group> */}

            <Search
              placeholder="주소 / 전화번호를 입력해주세요"
              enterButton
              allowClear
              style={{
                width: 300,
                marginLeft: 20,
              }}
              className="desk"
              // value={searchText}
              // onChange={(e) => setSearchText(e.target.value)}
              onSearch={(text) => {
                onSearch(text);
              }}
            />
            <Search
              placeholder="주소 / 전화번호를 입력해주세요"
              enterButton
              allowClear
              style={{
                width: 300,
                marginLeft: 20,
              }}
              className="pos"
              // value={searchText}
              // onChange={(e) => setSearchText(e.target.value)}
              onSearch={(text) => {
                onSearch(text);
              }}
            />
            <Search
              placeholder=""
              enterButton
              allowClear
              size="small"
              style={{
                width: 150,
                marginLeft: 10,
              }}
              className="mobile"
              // value={searchText}
              // onChange={(e) => setSearchText(e.target.value)}
              onSearch={(text) => {
                onSearch(text);
              }}
            />
          </FormItem>
          <div
            style={{ display: 'inline-block', marginLeft: 10 }}
            className="mobileoff">
            <div
              className="delivery-element-menu-text3"
              style={{ fontWeight: 600 }}>
              정렬
            </div>
            <div
              className={sortType === 0 && skinType === "GOGOIT"
                  ? 'gogoit-delivery-element-menu-text3 active'
                  : sortType === 0
                      ? 'delivery-element-menu-text3 active'
                      : 'delivery-element-menu-text3'
              }
              onClick={() => {
                setSortType(0);
              }}>
              기본
            </div>
            <div
              className={sortType === 1 && skinType === "GOGOIT"
                  ? 'gogoit-delivery-element-menu-text3 active'
                  : sortType === 1
                      ? 'delivery-element-menu-text3 active'
                      : 'delivery-element-menu-text3'
              }
              onClick={() => {
                setSortType(1);
              }}>
              시간순
            </div>
            <div
              className={sortType === 2 && skinType === "GOGOIT"
                  ? 'gogoit-delivery-element-menu-text3 active'
                  : sortType === 2
                      ? 'delivery-element-menu-text3 active'
                      : 'delivery-element-menu-text3'
              }
              onClick={() => {
                setSortType(2);
              }}>
              시간역순
            </div>
          </div>
          <div
            className={largeList && skinType === "GOGOIT"
                ? 'mobileoff gogoit-delivery-element-menu-text3 active'
                : largeList
                    ? 'mobileoff delivery-element-menu-text3 active'
                    : 'mobileoff delivery-element-menu-text3'
            }
            style={{ float: 'right' }}
            onClick={() => {
              setLargeList(!largeList);
            }}>
            크게보기
          </div>
          <Button
            className="mobileoff delivery-element-menu-text3"
            style={{
              float: 'right',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
            onClick={() => getListByApi()}>
            새로고침
          </Button>
        </div>
      </div>

      <div className="delivery-element">
        {riderChatOpen && (
          <ChatDetail
            selectedRider={selectedRider}
            close={closeRiderChatModal}
          />
        )}

        <div className="delivery-element-all">
          <div className="delivery-element-block">
            <div className="delivery-element-block-menu">
              <div className="delivery-element-block-menu-text mobileoff">
                주문번호
              </div>
              <div className="delivery-element-block-menu-text mobileoff">
                신청일시
              </div>
              <div className="delivery-element-block-menu-text delText4 mobileoff">
                준비시간
                <div className="delivery-element-block-menu-text-sub">
                  (경과시간)
                </div>
              </div>
              <div className="delivery-element-block-menu-text">상태</div>
              <div className="delivery-element-block-menu-text delText3">
                고객정보
              </div>
              <div className="delivery-element-block-menu-text delText4">
                상품가액
                <div className="delivery-element-block-menu-text-sub">
                  (배달료)
                </div>
              </div>
              <div className="delivery-element-block-menu-text  mobileoff">
                기사정보
              </div>

              <div className="delivery-element-block-menu-text  mobileoff">
                조리
              </div>
              <div className="delivery-element-block-menu-text  mobile">
                상세
              </div>
            </div>
          </div>
          <div className="procList-wrapper">
            {list &&
              list.map((row, index) => {
                if (!isShowAwaitOrderItem(row)) return;
                else return (
                <div
                  key={index}
                  className={
                    row.orderStatus !== orderStatusCode.none &&
                    duplicateList.find((x) => x === row.idx) !== undefined
                      ? 'delivery-element-block-field' +
                        (largeList ? ' large' : '') +
                        ' dup'
                      : 'delivery-element-block-field' +
                        (largeList ? ' large' : '') +
                        (index % 2 === 0 ? '' : ' odd')
                  }
                  onClick={() => {
                    onConfirmOder(row, false);
                  }}>
                  <div className="delivery-element-block-field-text mobileoff">
                    {row.orderStatus === orderStatusCode.none ? (
                      <div className="delivery-element-block-field-text1-btn">
                        <div
                          onClick={(event) => {
                            onDeleteItem(event, row);
                          }}>
                          삭제하기
                        </div>
                      </div>
                    ) : (
                      row.idx
                    )}
                  </div>
                  <div className="delivery-element-block-field-text mobileoff">
                    {moment(row.orderDate).format('HH:mm')}
                  </div>
                  <div className="delivery-element-block-field-text mobileoff">
                    {getDeliveryInfo(row)}
                    <div className="delivery-element-block-field-text-sub">
                      ({moment().diff(moment(row.orderDate), 'minute')}분)
                    </div>
                    {/* <div className="delivery-element-block-field-text-sub">
                                        {(row.basicDeliveryPrice + row.extraDeliveryPrice) > 0 &&
                                            `(${comma(row.basicDeliveryPrice + row.extraDeliveryPrice)}원)`}
                                    </div> */}
                  </div>
                  <div className="delivery-element-block-field-text">
                    <div
                      className={
                        'delivery-element-block-field-text' +
                          typeof row.waiting !==
                          'undefined' && row.waiting
                          ? '대기'
                          : getOrderStatusString(row.orderStatus)
                      }>
                      {typeof row.waiting !== 'undefined' && row.waiting
                        ? '대기'
                        : getOrderStatusString(row.orderStatus)}
                      {row.orderStatus === orderStatusCode.order &&
                        row.waitingStatus === 0 && (
                          <div
                            className="delivery-element-block-field-text9-btn mobileoff"
                            onClick={(event) => {
                              cancelOrder(event, row);
                            }}>
                            취소
                          </div>
                        )}
                      {row.orderStatus === orderStatusCode.order &&
                        row.waitingStatus === 1 && (
                          <div className="delivery-element-block-field-text-sub">
                            (대기)
                          </div>
                        )}
                    </div>
                    <div className="mobile">
                      ({moment().diff(moment(row.orderDate), 'minute')}분)
                    </div>
                  </div>

                  <div className="delivery-element-block-field-text del-sub3">
                    {row.destAddr3 ? (
                      <p style={{ margin: 0 }}>
                        {dosiguCodeReplace(`${row.destAddr3} ${row.destAddr2}`)}
                      </p>
                    ) : row.destAddr1 ? (
                      <p style={{ margin: 0, marginLeft: 6 }}>
                        {dosiguCodeReplace(`${row.destAddr1} ${row.destAddr2}`)}
                      </p>
                    ) : (
                      row.destAddr2
                    )}
                    {}
                    {/* <div className="delivery-element-block-field-text-sub">
                      ({row.custPhone})
                    </div> */}
                  </div>
                  <div className="delivery-element-block-field-text del-sub4">
                    {row.orderPayments
                      ? row.orderPayments.length === 0
                        ? ''
                        : row.orderPayments.length > 1
                        ? '분할'
                        : paymentMethodString[
                            row.orderPayments[0].paymentMethod
                          ]
                      : row.paymentMethod
                      ? paymentMethodString[row.paymentMethod]
                      : ''}
                    <div
                      className="delivery-element-block-field-text-sub"
                      style={{ marginLeft: '3px' }}>
                      {comma(row.orderPrice)}원
                      <div className="delivery-element-block-field-text-sub">
                        {row.basicDeliveryPrice + row.extraDeliveryPrice > 0 &&
                          `(${comma(
                            row.basicDeliveryPrice + row.extraDeliveryPrice
                          )}원)`}
                      </div>
                    </div>
                  </div>
                  <div className="delivery-element-block-field-text mobileoff">
                    <div
                      onClick={(e) => {
                        if (row.userIdx)
                          openRiderChatModal(row.userIdx, row.riderName, e);
                      }}
                      className="delivery-element-block-field-text-sub mobileoff">
                      {row.riderName} {row.riderPhone && `(${row.riderPhone})`}
                      {/* <div className="delivery-element-block-field-text-sub">
                        {row.riderPhone ? `(${row.riderPhone})` : "-"}
                      </div> */}
                    </div>
                  </div>
                  <div className="delivery-element-block-field-text mobileoff">
                    {row.orderStatus === orderStatusCode.none ? (
                      <div className="delivery-element-block-field-text1-btn">
                        <div
                          onClick={(event) => {
                            onUpdateItem(event, row);
                          }}>
                          수정하기
                        </div>
                      </div>
                    ) : (
                      <div
                        className={row.itemPrepared
                            ? 'delivery-element-block-field-text8'
                            : skinType === "GOGOIT"
                                ? 'gogoit-delivery-element-block-field-text7-btn'
                                : 'delivery-element-block-field-text7-btn'
                        }>
                        {row.orderStatus === orderStatusCode.none ? (
                          ''
                        ) : row.itemPrepared ? (
                          <div
                            style={{ display: 'flex', alignItems: 'center' }}>
                            완료
                            <div
                              className="delivery-element-block-field-text9-btn"
                              onClick={(event) => {
                                onChangeItemFlag(event, row);
                              }}>
                              취소
                            </div>
                          </div>
                        ) : (
                          <div
                            onClick={(event) => {
                              onChangeItemFlag(event, row);
                            }}>
                            완료하기
                          </div>
                        )}
                      </div>
                    )}
                  </div>

                  <div className="delivery-element-block-field-text mobile">
                    <Button
                      onClick={(event) => {
                        onConfirmOder(row, true);
                        event.stopPropagation();
                      }}
                      className="del-btn">
                      상세
                    </Button>
                  </div>
                </div>
              );})}
          </div>
        </div>
      </div>
      {/* </ScrollView> */}
    </div>
  );
};

const mapStateToProps = (state) => {
  const { posReducer, orderReducer, loginReducer } = state;
  return { posReducer, orderReducer, loginReducer };
};
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      addOrderInfo,
      removeWaitingOrder,
      removePosOrder,
      clearOrder,
      updateWaitingOrder,
      addWaitingOrder,
      updateManualPickupTimeSetup,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(ProcList);
